<template>
  <div >
    <b-row>
      <b-col>
        <Clock :state="flag" />
      </b-col>
      <b-col>
        <Tally @test="next" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Tally from "@/components/Tally";
import Clock from "@/components/clock";

export default {
  name: "PresenterDisplay",

  data: function() {
    return {
      flag: true,
    };
  },

  computed: {},

  methods: {
    next(flag){
      console.log(flag)
      this.flag=flag;
    }

  },



  beforeMount() {},

  components: {
    Tally,
    Clock,
  },
};
</script>
